import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { ErrorLayout } from 'src/components/templates/ErrorLayout';
import { LazyLoader } from './LazyLoader';

const SomethingWentWrong = LazyLoader(lazy(() => import('src/components/pages/others/SomethingWentWrongPage')));
const PageNotFound = LazyLoader(lazy(() => import('src/components/pages/others/PageNotFound')));
const SubscriptionBlocker = LazyLoader(lazy(() => import('src/components/pages/others/PremiumPageBlocker')));

export const errorPageRoutes = {
  path: '*',
  element: <ErrorLayout />,
  children: [
    {
      path: '',
      element: <Navigate to='/auth/login' />
    },
    {
      path: '404',
      element: <PageNotFound type='auth-custom' title='pages.others.page_not_found.title_head' />
    },
    {
      path: '500',
      element: <SomethingWentWrong type='auth-custom' title='pages.others.something_went_wrong.title_head' />
    },
    {
      path: 'premium-required',
      element: <SubscriptionBlocker type='auth-custom' title='pages.others.subscription_blocker.title_head' />
    },
    {
      path: 'ui/verification/*',
      element: <Navigate to='/auth/login' />
    },
    {
      path: '*',
      element: <Navigate to='/404' />
    }
  ]
};

export type ErrorPageTitle =
  | 'pages.others.page_not_found.title_head'
  | 'pages.others.something_went_wrong.title_head'
  | 'pages.others.subscription_blocker.title_head';
